/* eslint-disable camelcase */

export enum DeviceType {
  Pc = "PC",
  AndroidMobileWeb = "ANDROID_MOBILE_WEB",
  AndroidTablet = "ANDROID_TABLET",
  AndroidApp = "ANDROID_APP",
  IosMobileWeb = "IOS_MOBILE_WEB",
  IosTablet = "IOS_TABLET",
  IosApp = "IOS_APP",
  SmartTv = "SMART_TV",
  AndroidTv = "ANDROID_TV",
  Others = "OTHERS",
  Windows = "Windows",
  ChromeOs = "ChromeOS",
  MacOs = "macOS",
  Linux = "Linux",
  Android = "Android",
  Ios = "iOS",
}

export type ByDevice<T> = T & {
  device: DeviceType;
};

export type ByRegion<T> = T & {
  region: string;
};
interface Count {
  count: number;
}

interface UniqueUsers<Data> {
  all: Data[] | null;
  live: Data[] | null;
  vod: Data[] | null;
  live_report_updated_at: number;
  vod_report_updated_at: number;
}

export type UniqueUsersByRegion = UniqueUsers<ByRegion<Count>>;

export type UniqueUsersByDevice = UniqueUsers<ByDevice<Count>>;

export type WatchTimeByDevice = ByDevice<{
  watch_time: number;
}>;

export type WatchTimeByRegion = ByRegion<{
  watch_time: number;
}>;

export type WatchTimeUserPercent = Count & {
  percent: string;
};

export interface WatchTime {
  devices: WatchTimeByDevice[] | null;
  regions: WatchTimeByRegion[] | null;
  user_percents: WatchTimeUserPercent[] | null;
  watch_time_average: number;
  updated_at: number;
}
